module.exports = __webpack_public_path__ + "media/explosion.8e16054f.mp3";